import config from 'shared/config/config.js';

var apiHost,
  appHost,
  stripeKey,
  webSocketUrl;

switch (config.env) {
  case 'production':
    apiHost = "https://api.capturelife.com";
    appHost = "https://app.capturelife.com/";
    stripeKey = "pk_test_6gskLUqlbPpreKxa3hMOdYFl";
    webSocketUrl = "wss://api.capturelife.com/websocket";
    break;

  case 'staging':
    apiHost = "https://staging-api.capturelife.com";
    appHost = "https://staging.capturelife.com";
    stripeKey = "pk_test_6gskLUqlbPpreKxa3hMOdYFl";
    webSocketUrl = "wss://staging-api.capturelife.com/websocket";
    break;

  case 'local':
    // TODO: No longer using docker internal network, by way of nginx,
    // since it breaks cacheBustUrl and doesn't appear to be necessary
    // apiHost = "/app";
    apiHost = "http://localhost:8901";
    appHost = "http://localhost";
    stripeKey = "pk_test_6gskLUqlbPpreKxa3hMOdYFl";
    webSocketUrl = "ws://localhost:8901/websocket";
    break;

  case 'npm-start':
    apiHost = "http://localhost:8901";
    appHost = "http://localhost";
    stripeKey = "pk_test_6gskLUqlbPpreKxa3hMOdYFl";
    webSocketUrl = "ws://localhost:8901/websocket";
    break;

  default:
    apiHost = "https://dev.capturelife.com:8901";
    appHost = "https://dev.capturelife.com:8900";
    stripeKey = "pk_test_6gskLUqlbPpreKxa3hMOdYFl";
    webSocketUrl = "wss://dev.capturelife.com:8901/websocket";
}

switch (config.env) {
  case 'local':
    if (config.customer === 'hpx') {
      appHost = appHost + ':8906';
    } else {
      appHost = appHost + ':8903';
    }
    break;

  case 'staging':
    if (config.customer === 'hpx') {
      appHost = appHost + ':3008';
    } else {
      appHost = appHost + ':3000';
    }
    break;

  case 'production':
    if (config.customer === 'hpx') {
      appHost = "https://harrypotterexhibition.capturelife.com";
    }
}

export const API_BASE_URL = apiHost;
export const APP_BASE_URL = appHost;
export const WEB_SOCKET_URL = webSocketUrl;
export const TILBY_APP_URL = "tilby://cashregister"

export const PORTRAIT_ORIENTATION = 0;
export const LANDSCAPE_ORIENTATION = 1;

// proxy
// "https://private-f0665-capturelifeapp.apiary-proxy.com";

// mock server
// "https://private-f0665-capturelifeapp.apiary-mock.com";

// ENDPOINTS

export const TERMS_AND_CONDITIONS_URL = "https://www.capturelife.com/terms/";
export const SUPPORT_URL = "https://www.capturelife.com/support";

export const ME_URL = API_BASE_URL + "/user/me";
export const ME_URL_V2 = API_BASE_URL + "/users/me";
export const LOGIN_URL = API_BASE_URL + "/user/login";
export const LOGOUT_URL = API_BASE_URL + "/user/logout";
export const REGISTER_URL = API_BASE_URL + "/user";
export const AVATAR_URL = user => `${API_BASE_URL}/users/${user.id}/avatar`;

export const UPDATE_MFA_INFO_URL = () => {
  return `${API_BASE_URL}/user/update_mfa_info`;
}

export const SHOW_MFA_REGISTRATION_QR_URL = () => {
  return `${API_BASE_URL}/user/generate_mfa_registration`;
}

export const VERIFY_2FA_CODE_URL = () => {
  return `${API_BASE_URL}/user/verify_2fa`;
}

export const UPDATE_ME_URL = () => {
  return `${API_BASE_URL}/users/me`;
}

export const GET_STORIES_URL = API_BASE_URL + "/story?t=" + Date.now();
export const GET_STORY_URL = API_BASE_URL + "/story";
export const CREATE_STORY_URL = API_BASE_URL + "/story/";
export const DELETE_STORY_URL = API_BASE_URL + "/story/:";
export const ADD_MOMENTS_TO_STORY_URL = API_BASE_URL + "/story/add/";

export const STORY_ACCOUNT_SETTINGS_URL = storyId => {
  return `${API_BASE_URL}/stories/${storyId}/account_settings?`;
}

export const STORY_CHECKOUT_SETTINGS_URL = storyId => {
  return `${API_BASE_URL}/stories/${storyId}/stripe_checkout_settings`;
}

export const STORY_DOWNLOAD_URL = (storyId, filename) => {
  return `${API_BASE_URL}/stories/${storyId}/download/${filename}`;
}

export const STORY_DOWNLOAD_URL_V2 = (storyId, momentIds, filename) => {
  if (momentIds) {
    return `${API_BASE_URL}/download/story/${storyId}/${btoa(momentIds.join('+'))}/${filename}`;
  } else {
    return `${API_BASE_URL}/download/story/${storyId}/all/${filename}`;
  }
}

export const STORY_MARK_VIEWED_URL = storyId => {
  return `${API_BASE_URL}/story/mark_viewed/${storyId}`;
}

export const CREATE_MOMENT_URL = API_BASE_URL + "/moment";
export const CREATE_MOMENTS_URL = API_BASE_URL + "/portal/moments";
export const GET_MOMENT_UPLOAD_URL = API_BASE_URL + "/moment/upload/";
export const UPDATE_MOMENT_URL = API_BASE_URL + "/moment/";

export const GET_SELFIE_URL = storyId => {
  return `${API_BASE_URL}/selfie/${storyId}`;
}

export const GET_SELFIE_UPLOAD_URL = storyId => {
  return `${API_BASE_URL}/selfie/${storyId}/upload`;
}

export const MATCH_SELFIE_URL = storyId => {
  return `${API_BASE_URL}/selfie/${storyId}/match`;
}

export const SUBMIT_SELFIE_URL = storyId => {
  return `${API_BASE_URL}/selfie/${storyId}/submit`
}

export const PROCESS_THUMBNAIL_URL = (momentId, editSource, printSize) => {
  const editContext = editSource ? `?edit_source=${editSource}&print_size=${encodeURIComponent(printSize)}` : '';
  return `${API_BASE_URL}/moment/${momentId}/process_thumbnails${editContext}`;
}

export const MOMENT_UPLOAD_URL = (momentId, type, asJson, editSource, printSize) => {
  const editContext = editSource ? `&edit_source=${editSource}&print_size=${encodeURIComponent(printSize)}` : '';
  return `${API_BASE_URL}/moment/upload/${momentId}?type=${type}&as_json=${asJson}${editContext}`;
}

export const MOMENT_PREVIEW_URL = momentId => {
  return `${API_BASE_URL}/moment/url?id=${momentId}&scale=f`;
}

export const MOMENT_PREVIEW_URL_SMALL = momentId => {
  return `${API_BASE_URL}/moment/url?id=${momentId}&scale=i`;
}

export const MOMENT_THUMB_URL = momentId => {
  return `${API_BASE_URL}/moment/url?id=${momentId}&scale=t`;
}

export const MOMENT_THUMB_URL_LARGE = momentId => {
  return `${API_BASE_URL}/moment/url?id=${momentId}&scale=p`;
}

export const MOMENT_PRINT_URL = momentId => {
  return `${API_BASE_URL}/moment/url?id=${momentId}`;
}

export const ANNOTATED_MOMENT_DOWNLOAD_URL = momentId => {
  return `${API_BASE_URL}/moments/${momentId}/download?include_access_code=true`;
}

export const MOMENT_DOWNLOAD_URL = momentId => {
  return `${API_BASE_URL}/moments/${momentId}/download`;
}

export const GET_MOMENT_METADATA_URL = API_BASE_URL + "/moment/";
export const ADD_IMAGE_TO_MOMENT_URL = API_BASE_URL + "/moment/file";
export const GET_MOMENTS_FROM_STORY_URL = API_BASE_URL + "/story/moments?";

export const GET_STORY_MOMENTS_URL = (storyId, page, perPage, opts = {}) => {
  let url = `${API_BASE_URL}/story/moments?story_id=${storyId}&page=${page}&per_page=${perPage}`
  for (let k in opts) {
    url += "&" + k + '=' + opts[k];
  }
  return url;
}
// https://staging-api.capturelife.com/moments/storage?story_id=13123


export const GET_MOMENT_URLS_FROM_STORY_URL = API_BASE_URL + "/story/moments/storage?story_id=";

export const PURCHASE_URL = `${API_BASE_URL}/moment/purchase`;

export const PURCHASES_URL = storyId => {
  return `${API_BASE_URL}/purchases?story_id=${storyId}`;
}

export const PURCHASE_REQUEST_URL = token => {
  return `${API_BASE_URL}/kiosk/${token}/purchase_requests`;
}

export const SCREEN_WIDTH_BREAKPOINT = 600;

export const MOMENT_VIEW_EDGE_TOLERANCE = 6;

export const LOG_URL = API_BASE_URL + '/log/client_errors';
export const LOG_DEBUG_URL = API_BASE_URL + '/log/client_debug';

export const GET_DEFAULT_SHARE_PAGE_URL = storyId => {
  return `${API_BASE_URL}/share_page?story_id=${storyId}`;
}
export const CREATE_SHARE_PAGE_URL = API_BASE_URL + '/share_page';

export const ANALYTICS_EVENTS_URL = API_BASE_URL + '/analytics/events';

export const PASSWORD_RESET_URL = API_BASE_URL + '/user/forgot_password';
export const PASSWORD_RESET_LOGIN_URL = API_BASE_URL + '/user/password_reset_login';
export const PASSWORD_UPDATE_URL = API_BASE_URL + '/user/update_password';
export const USERNAME_UPDATE_URL = userId => {
  return `${API_BASE_URL}/user/${userId}`;
}

export const ACCOUNT_PIN_UPDATE_URL = accountId => {
  return `${API_BASE_URL}/accounts/${accountId}/user/pin`;
}

export const CART_ITEMS_URL = storyId => {
  return `${API_BASE_URL}/v2/cart/${storyId}/items`;
}

export const CART_MOMENTS_URL_V2 = (storyId, page, perPage) => {
  return `${API_BASE_URL}/v2/cart/${storyId}/moments?page=${page}&per_page=${perPage}`;
  //return `${API_BASE_URL}/story/moments?story_id=${storyId}&premium=true&include_thumb_urls=true&include_large_thumb_urls=true&include_preview_urls=true&include_small_preview_urls=true&include_print_urls=true&page=${page}&per_page=${perPage}`;
}

export const CART_MOMENT_URL_V2 = (storyId, momentId) => {
  return `${API_BASE_URL}/v2/cart/${storyId}/moments/${momentId}`;
}

export const PURCHASED_MOMENT_IDS_URL = (storyId) => {
  return `${API_BASE_URL}/v2/cart/${storyId}/purchased_moment_ids`;
}

export const CART_MOMENT_URL = (storyId, momentId) => {
  return `${API_BASE_URL}/stories/${storyId}/moments/${momentId}`;
}

export const PRINTS_URL = storyId => {
  return `${API_BASE_URL}/kiosk/prints/${storyId}`;
}

export const THEME_HEADER_URL = themeId => {
  return `${API_BASE_URL}/user/embedded/${themeId}/asset/header`;
}

export const PRINT_SIZE_SELECTION_URL = storyId => {
  return `${API_BASE_URL}/cart/print_sizes/${storyId}`;
}

export const CLEAR_PRINT_SIZE_SELECTION = (storyId, momentId) => {
  return `${API_BASE_URL}/cart/print_sizes/${storyId}/clear/${momentId}`;
}

export const STRIPE_COLLECT_PAYMENT_URL = (accountId) => {
  return `${API_BASE_URL}/stripe/${accountId}/create_payment_intent`;
}

export const STRIPE_PROCESS_PAYMENT_URL = (accountId) => {
  return `${API_BASE_URL}/stripe/${accountId}/process_payment_intent`;
}

export const PURCHASE_CALCULATIONS_URL = `${API_BASE_URL}/purchase/calculations`;
export const APPLY_DISCOUNT_CODE_URL = `${API_BASE_URL}/products/apply_discount_code`;

export const REGISTER_STRIPE_TERMINAL_URL = (accountId) => {
  return `${API_BASE_URL}/stripe/${accountId}/register_reader`;
}

export const CANCEL_STRIPE_TERMINAL_URL = (accountId) => {
  return `${API_BASE_URL}/stripe/${accountId}/cancel_reader`;
}

export const RE_KNOCKOUT_MOMENT_URL = (momentId, kioskToken) => {
  return `${API_BASE_URL}/reknockout/${momentId}?token=${kioskToken}`;
}

export const PRINT_ORDER_URL = (purchaseId) => {
  return `${API_BASE_URL}/cart/purchased_prints/${purchaseId}`;
}

export const KIOSK_PRICINGS_URL = (kioskId) => {
  return `${API_BASE_URL}/kiosks/${kioskId}/pricing`;
}

export const KIOSK_PRICING_URL = (kioskId, pricingId) => {
  return `${API_BASE_URL}/kiosks/${kioskId}/pricing/${pricingId}`;
}

export const JOB_MARKETING_URL = (jobId) => {
  return `${API_BASE_URL}/marketing_by_job_id/${jobId}`
}

export const MARKETING_POPUP_IMAGE_URL = (marketingId) => {
  return `${API_BASE_URL}/marketing/${marketingId}/popup_image?t=${Date.now()}`;
}

export const TILBY_CASHREGISTER_URL = (saleId) => {
  return `${TILBY_APP_URL}/sale/${saleId}?autohide=true&advancedpayments=true`
}

export const TILBY_CREATE_URL = (accountId) => {
  return `${API_BASE_URL}/tilby/${accountId}/create_payment`
}

export const TILBY_INIT_WEBHOOK_URL = (accountId) => {
  return `${API_BASE_URL}/tilby/${accountId}/init_webhook`
}

export const TILBY_DELETE_WEBHOOK_URL = (webhookId) => {
  return `${API_BASE_URL}/tilby/webhook/${webhookId}`;
}

export const ACCOUNT_URL = (accountId) => {
  return `${API_BASE_URL}/accounts/${accountId}`;
}

export const DISABLED_PRINT_MODE = 0;
export const LEGACY_PRINT_MODE = 1;
export const MULTI_PRINT_MODE = 2;
export const SIZED_PRINT_MODE = 3;

export const HAGGLE_CHECKOUT_TYPE = 0;
export const MARKETPLACE_CHECKOUT_TYPE = 1;
export const KIOSK_PRICING_CHECKOUT_TYPE = 2;

export const ACCESS_CODE_LOGIN_TYPE = 0;
export const EMAIL_LOGIN_TYPE = 1;
export const CLUB_MED_LOGIN_TYPE = 2;

export const GENERIC_POS = 0;
export const BILL_TO_ROOM_POS = 1;

export const DEFAULT_PAGE_MODE = 0;
export const CLUBMDED_PAGE_MODE = 1;
export const HAWKS_PAGE_MODE = 2;
export const EMAIL_PAGE_MODE = 4;

export const LOCALE_EN_US = 'en-us';
export const LOCALE_DE_AT = 'de-at';
export const LOCALE_FR_FR = 'fr-fr';
export const LOCALE_ES_ES = 'es-es';
export const LOCALE_ZH_CN = 'zh-cn';
export const LOCALE_PT_BR = 'pt-br';
export const LOCALE_PL_PL = 'pl-pl';
export const LOCALE_IT_IT = 'it-it';
export const LOCALE_HU_HU = 'hu-hu';
export const LOCALE_NL_NL = 'nl-nl';
export const LOCALE_CS_CZ = 'cs-cz';

export const LOCALES = [
  { name: 'English', locale: LOCALE_EN_US, flag: 'gb' },
  { name: 'Spanish', locale: LOCALE_ES_ES, flag: 'es' },
  { name: 'German', locale: LOCALE_DE_AT, flag: 'de' },
  { name: 'French', locale: LOCALE_FR_FR, flag: 'fr' },
  { name: 'Portuguese', locale: LOCALE_PT_BR, flag: 'br' },
  { name: 'Chinese', locale: LOCALE_ZH_CN, flag: 'cn' },
  { name: 'Polish', locale: LOCALE_PL_PL, flag: 'pl' },
  { name: 'Italian', locale: LOCALE_IT_IT, flag: 'it' },
  { name: 'Hungarian', locale: LOCALE_HU_HU, flag: 'hu' },
  { name: 'Dutch', locale: LOCALE_NL_NL, flag: 'nl' },
  { name: 'Czech', locale: LOCALE_CS_CZ, flag: 'cz' },
]

export const URL_LOGO_TYPE = 0;
export const GCLOUD_LOGO_TYPE = 1;

export const CATALOG_SCREEN = 0;
export const GALLERY_SCREEN = 1;

export const DOUBLE_PANE_RECEIPT = 0;
export const SINGLE_PANE_RECEIPT = 1;

export const SUBSCRIPTION_WEEKLY = 1;
export const SUBSCRIPTION_MONTHLY = 2;
export const SUBSCRIPTION_ANNUAL = 3;

export const SCHEDULE_TYPE_ASAP = 1;
export const SCHEDULE_TYPE_SCHEDULED = 2;

export const CURRENCIES = [
  { abbr: 'USD', symbol: '$' },
  { abbr: 'CAD', symbol: '$' },
  { abbr: 'MXN', symbol: '$' },
  { abbr: 'DOP', symbol: '$' },
  { abbr: 'MOP', symbol: '$' },
  { abbr: 'GBP', symbol: '£' },
  { abbr: 'EUR', symbol: '€' },
  { abbr: 'AUD', symbol: '$' },
  { abbr: 'MYR', symbol: 'RM' },
  { abbr: 'BBD', symbol: '$' },
  { abbr: 'BRL', symbol: 'R$' },
  { abbr: 'PLN', symbol: 'zł' },
  { abbr: 'AED', symbol: 'د.إ' },
  { abbr: 'HUF', symbol: 'Ft' },
  { abbr: 'CZK', symbol: 'Kč' },
]

export const MIMETYPES = {
  "image/jpeg": "jpeg",
  "image/png": "png",
  "image/gif": "gif",
  "video/quicktime": "mov",
  "video/mp4": "mp4"
}

export const LEGACY_THEME = 'legacy';
export const CLUBMED_THEME = 'clubmed';
export const HPX_THEME = 'hpx';
export const ICECASTLE_THEME = 'icecstl';
